module.exports = "<div class=\"gw-policy-details-title\">\r\n    {{'billing.directives.templates.billing-line-policies-summary.Invoice Policy Details' | translate}}\r\n</div>\r\n<div ng-repeat=\"policy in gwBillingPaymentLinePoliciesSummary\" class=\"gw-policy-info\">\r\n    <a class=\"gw-action-link\" href=\"#/account-policy-details/{{policy}}\">{{policy}}</a></div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/billing/directives/templates/billing-line-policies-summary.html
// module id = 542
// module chunks = 0